<template>
	<div class="install-extension">
		<h1>נדרש תוסף לדפדפן</h1>
		<p>כדי לבדוק זמינות ולסנכרן בבטחה את עוגיות YouTube לפני הורדה, יש להתקין את הגרסה העדכנית של התוסף.</p>

		<div class="instructions">
			<h2>הוראות התקנה:</h2>
			<ol>
				<li>הורד את קובץ ה-ZIP מהקישור למטה.</li>
				<li>חלץ (Extract) את הקבצים מתוך ה-ZIP לתיקייה חדשה במחשב. אם מותקנת גרסה קודמת, החלף אותה.</li>
				<li>פתח את הדפדפן בכתובת <code>chrome://extensions</code>.</li>
				<li>הפעל את "מצב מפתח" (Developer mode) בפינה העליונה.</li>
				<li>לחץ על "Load unpacked" (טען תוסף לא ארוז) ובחר את התיקייה שחילצת.</li>
				<li>ודא שהתוסף מופיע ברשימה ומופעל, ולחץ Reload אם החלפת קבצים של גרסה קודמת.</li>
				<li>אשר לתוסף לקרוא עוגיות מ־youtube.com ולגשת לשירות ההורדות.</li>
				<li>חזור לכאן ורענן את הדף.</li>
			</ol>

			<a href="/netfree-check-extension.zip?v=1.1.0" class="download-btn" download>הורד תוסף מעודכן</a>
		</div>

		<div v-if="checking" class="status-message">
			בודק אם התוסף מותקן...
		</div>
		<div v-else-if="checkComplete && extensionOutdated" class="status-message error">
			זוהתה גרסה ישנה של התוסף. הורד את הגרסה החדשה, החלף את התיקייה ולחץ Reload ב־Chrome.
		</div>
		<div v-else-if="checkComplete && !extensionFound" class="status-message error">
			התוסף עדיין לא זוהה. ודא שהתקנת ורעננת את התוסף ב-Chrome.
		</div>

		<button @click="reloadPage" class="retry-btn">
			התוסף הותקן? לחץ כאן לרענון ובדיקה
		</button>
	</div>
</template>

<script>
const REQUIRED_EXTENSION_CAPABILITY = 'youtube-cookie-sync-v1';

export default {
	name: 'InstallExtension',
	data() {
		return {
			checking: false,
			checkComplete: false,
			extensionFound: false,
			extensionOutdated: false
		};
	},
	mounted() {
		// בדיקה אוטומטית בטעינה
		this.checkExtensionAndRedirect();
	},
	methods: {
		reloadPage() {
			window.location.reload();
		},
		checkExtensionAndRedirect() {
			this.checking = true;
			this.checkComplete = false;
			this.extensionOutdated = false;

			this.checkIfExtensionInstalled().then(isInstalled => {
				this.checking = false;
				this.checkComplete = true;
				this.extensionFound = isInstalled;

				if (isInstalled) {
					console.log('Extension detected via Install Page! Redirecting to home...');
					this.$router.push('/');
				}
			});
		},
		checkIfExtensionInstalled() {
			return new Promise((resolve) => {
				let attempts = 0;
				const maxAttempts = 10; // Try for ~2 seconds

				const pongListener = (event) => {
					if (event.source === window && event.origin === window.location.origin &&
						event.data && event.data.type === 'CHECK_NETFREE_PONG') {
						clearInterval(pingInterval);
						window.removeEventListener('message', pongListener);

						const capabilities = Array.isArray(event.data.capabilities) ? event.data.capabilities : [];
						const isCurrentVersion = capabilities.includes(REQUIRED_EXTENSION_CAPABILITY);
						this.extensionOutdated = !isCurrentVersion;
						resolve(isCurrentVersion);
					}
				};

				window.addEventListener('message', pongListener);

				const sendPing = () => window.postMessage(
					{ type: 'CHECK_NETFREE_PING' },
					window.location.origin
				);
				sendPing();

				const pingInterval = setInterval(() => {
					attempts++;
					if (attempts >= maxAttempts) {
						clearInterval(pingInterval);
						window.removeEventListener('message', pongListener);
						resolve(false);
					} else {
						sendPing();
					}
				}, 200);
			});
		}
	}
}
</script>

<style scoped>
.status-message {
	margin: 15px 0;
	font-weight: bold;
	color: #666;
}

.status-message.error {
	color: #d32f2f;
}

.install-extension {
	text-align: center;
	padding: 40px;
	max-width: 600px;
	margin: 0 auto;
}

h1 {
	color: #4285F4;
}

.instructions {
	background: #f9f9f9;
	padding: 20px;
	border-radius: 8px;
	margin: 30px 0;
	text-align: right;
}

.download-btn {
	display: inline-block;
	background: #34A853;
	color: white;
	padding: 10px 20px;
	text-decoration: none;
	border-radius: 5px;
	margin-top: 20px;
	font-weight: bold;
}

.retry-btn {
	background: #4285F4;
	color: white;
	border: none;
	padding: 12px 24px;
	border-radius: 5px;
	cursor: pointer;
	font-size: 16px;
}
</style>
